<template>
  <div id="qw-app">
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="scss">
#qw-app {
    min-height: 100vh;
}
</style>
